"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCmsApiBaseUrl = (config) => {
    return `${config.baseURL}${config.apiBasePath}${config.cmsApiPath}`;
};
//# sourceMappingURL=path.js.map